import React from 'react';
import { slugify } from '../../../utils.jsx';

class StaticTextsModalDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      cid: this.props.cid,
      name: this.props.name,
      cidChanged: false,
      isNew: this.props.cid ? false : true,
    };

    this.onChangeName = this.onChangeName.bind(this);
    this.onChangeCid = this.onChangeCid.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onChangeName(e) {
    var self = this;
    this.setState({ name: e.target.value }, function() {
      if (!self.state.cidChanged && self.state.isNew) {
        self.setState({ cid: slugify(self.state.name) });
      }
    });
  }

  onChangeCid(e) {
    this.setState({ cid: e.target.value, cidChanged: true });
  }

  onSubmit(e) {
    e.preventDefault();

    if (this.state.name.trim().length === 0) {
      alert('Zadajte názov statického textu');
      return;
    }

    if (this.state.cid.trim().length === 0) {
      alert('Zadajte identifikátor statického textu');
      return;
    }

    this.props.onSubmit({
      cid: this.state.cid,
      name: this.state.name,
    });
  }

  render() {
    return (
      <div>
        <form onSubmit={this.onSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label htmlFor="content-dialog-name" className="title">
                Názov
              </label>
              <input
                type="text"
                placeholder="Vyplňte názov"
                className="form-control"
                id="content-dialog-name"
                onChange={this.onChangeName}
                value={this.state.name}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="content-dialog-url" className="title">
                Identifikátor
              </label>
              <input
                type="text"
                disabled={!this.props.isNew}
                placeholder="Jednoznačný identifikátor"
                className="form-control"
                id="content-dialog-url"
                onChange={this.onChangeCid}
                value={this.state.cid}
                required
              />
            </div>
          </div>
          <div className="modal-footer">
            {this.state.isNew ? null : (
              <button
                type="button"
                className="btn btn-danger pull-left"
                onClick={this.props.onDelete.bind(null, this.props.cid)}
              >
                <span className="fa fa-trash" />&nbsp;Odstrániť
              </button>
            )}
            <button type="submit" className="btn btn-primary">
              <span className="fa fa-floppy-o" />&nbsp;Uložiť
            </button>
          </div>
        </form>
      </div>
    );
  }
}

export default StaticTextsModalDialog;



// WEBPACK FOOTER //
// ./src/js/app/cm/components/StaticTextForm.jsx